import React, { useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import users from "../../data/user";

export default function LoginForm() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const foundUser = users.find(
      (u) => u.email === email && u.password === password
    );
    if (foundUser) {
      login({ name: foundUser.name, email: foundUser.email });
      navigate("/");
    } else {
      setError("E-posta veya şifre yanlış.");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div
        className="card shadow border-0 rounded-0"
        style={{ maxWidth: "420px", width: "100%" }}
      >
        {/* Card Header */}
        <div className="card-header bg-white text-center py-4 border-0">
          <h4 className="fw-semibold mb-1">Sign in</h4>
          <p className="text-muted small mb-0">Login to your account</p>
        </div>

        {/* Card Body */}
        <div className="card-body px-4 py-4">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label small">
                Email address
              </label>
              <input
                type="email"
                className="form-control rounded-0"
                id="email"
                placeholder="email@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label small">
                Password
              </label>
              <input
                type="password"
                className="form-control rounded-0"
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="remember"
                />
                <label className="form-check-label small" htmlFor="remember">
                  Remember me
                </label>
              </div>

              <a href="#" className="small text-decoration-none">
                Forgot password?
              </a>
            </div>

            {error && (
              <div className="alert alert-danger py-2 small" role="alert">
                {error}
              </div>
            )}

            <button type="submit" className="btn btn-dark w-100 rounded-0 py-2">
              Sign in
            </button>
          </form>
        </div>

        {/* Card Footer */}
        <div className="card-footer bg-white text-center py-3 border-0">
          <span className="small text-muted">Don’t have an account?</span>{" "}
          <a href="/signup" className="small fw-semibold text-decoration-none">
            Sign up
          </a>
        </div>
      </div>
    </div>
  );
}
